module.exports = __webpack_public_path__ + "static/media/options.aaedd561.svg";